import { combineReducers } from "redux";
import chnage_stock from "../features/admin/change_stock/chnage_stock/slice";
import market_price_history from "../features/admin/change_stock/market_price_history/slice";

const ChnageStocks = combineReducers({
  chnage_stock: chnage_stock,
  market_price_history: market_price_history,
});

export default ChnageStocks;
